import { Type } from '@angular/core';

import { BowType, BowTypeLabel, Division, DivisionLabel } from '@core/models/brijjsports.enums';

import { SportDefinition, SportProfileField } from '../sport.types';
import { ArcheryScoringAdapter } from './archery-scoring.adapter';
import { ArcherySpectatorComponent } from './components/archery-spectator.component';

// Re-exports so consumers don't reach into core/models for archery enums.
export { Division, DivisionLabel, BowType, BowTypeLabel };

const profileFields: SportProfileField[] = [
  {
    key: 'division',
    label: 'Division',
    section: 'profile',
    type: 'select',
    filterable: true,
    options: Object.entries(DivisionLabel).map(([value, label]) => ({ value: Number(value), label }))
  },
  {
    key: 'bowType',
    label: 'Bow type',
    section: 'profile',
    type: 'select',
    filterable: true,
    options: Object.entries(BowTypeLabel).map(([value, label]) => ({ value: Number(value), label }))
  },
  { key: 'targetScore', label: 'Target score', section: 'profile', type: 'number', min: 0, max: 1440 },
  { key: 'pin', label: 'JOAD pin', section: 'profile', type: 'text' },

  {
    key: 'equipment.bowType',
    label: 'Bow type',
    section: 'equipment',
    type: 'select',
    options: Object.entries(BowTypeLabel).map(([value, label]) => ({ value: Number(value), label }))
  },
  { key: 'equipment.bowModel', label: 'Bow model', section: 'equipment', type: 'text' },
  { key: 'equipment.sightSettings', label: 'Sight settings', section: 'equipment', type: 'text' },
  { key: 'equipment.rest', label: 'Arrow rest', section: 'equipment', type: 'text' },
  { key: 'equipment.arrows', label: 'Arrows', section: 'equipment', type: 'text' }
];

export function createArcherySportDefinition(input: {
  scoring: ArcheryScoringAdapter;
  setupComponent: Type<unknown>;
  liveComponent: Type<unknown>;
}): SportDefinition {
  return {
    key: 'archery',
    label: 'Archery',
    icon: 'sports_score',
    colorToken: '--brijjsports-blue',
    athletesNoun: 'Archers',
    terminology: {
      eventNoun: 'Shoot',
      eventNounPlural: 'Shoots',
      sessionNoun: 'Round',
      opponentNoun: 'Competitor',
      scoreUnitNoun: 'Arrow score',
      resultPlacementHelp: '1st, Bronze, Top 8'
    },
    rulesSummary: 'Archers shoot ends of arrows at scored target faces; ranking rounds and Olympic match-play sets are tracked.',
    scoring: input.scoring,
    profileFields,
    setupComponent: input.setupComponent,
    liveComponent: input.liveComponent,
    spectatorComponent: ArcherySpectatorComponent,
    nav: {
      owner: [{ route: '/owner/athletes', label: 'Archers', icon: 'award' }],
      coach: [
        { route: '/coach/roster', label: 'Archers', icon: 'award' },
        { route: '/coach/scoring', label: 'Score sheets', icon: 'list' }
      ],
      athlete: [{ route: '/athlete/scores', label: 'Round scores', icon: 'list' }]
    }
  };
}
